import {
  STORE
} from '../constants'

export const shopifyShopDomains = {
  [STORE.SHOPIFY_TW]: 'rhinoshieldtaiwan.myshopify.com',
  [STORE.SHOPIFY_ASIA]: 'rhinoshieldasia.myshopify.com',
  [STORE.SHOPIFY_IO]: 'rhinoshield.myshopify.com',
  [STORE.SHOPIFY_FR]: 'rhinoshieldfr.myshopify.com',
  [STORE.SHOPIFY_DE]: 'rhinoshieldde.myshopify.com',
  [STORE.SHOPIFY_EU]: 'rhinoshieldeu.myshopify.com',
  [STORE.SHOPIFY_JP]: 'rhinoshieldjp.myshopify.com',
  [STORE.SHOPIFY_ES]: 'rhinoshieldes.myshopify.com',
  [STORE.SHOPIFY_UK]: 'rhinoshielduk.myshopify.com',
  [STORE.SHOPIFY_VN]: 'rhinoshieldvn.myshopify.com',
  [STORE.SHOPIFY_KR]: 'rhinoshieldkr.myshopify.com',
  [STORE.SHOPIFY_TH]: 'rhinoshieldth.myshopify.com',
  [STORE.SHOPIFY_B2B_FR]: 'rhinoshieldb2bfr.myshopify.com',
  [STORE.SHOPIFY_B2B_WW]: 'rhinoshieldb2bww.myshopify.com',
  [STORE.SHOPIFY_B2B_EN]: 'rhinoshieldb2ben.myshopify.com',
  [STORE.SHOPIFY_B2B_TW]: 'rhinoshieldb2b.myshopify.com',
  [STORE.SHOPIFY_KROMA]: 'getkroma.myshopify.com',
  [STORE.SHOPIFY_KROMA_TW]: 'getkromatw.myshopify.com',
  [STORE.SHOPIFY_KROMA_FR]: 'may-dev.myshopify.com',
  [STORE.SHOPIFY_DEV]: 'getkromafr.myshopify.com'
}